import { render } from "./BookDetail.vue?vue&type=template&id=1e37d0db&scoped=true"
import script from "./BookDetail.vue?vue&type=script&lang=js"
export * from "./BookDetail.vue?vue&type=script&lang=js"

import "./BookDetail.vue?vue&type=style&index=0&id=1e37d0db&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1e37d0db"

export default script